import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

interface OBInProgressPageProps {
  className?: string;
}

const OBInProgressPage: FunctionComponent<OBInProgressPageProps> = ({
  className = "",
}) => {
  const { t } = useTranslation();

  return (
    <div className={`app-onboarding onboarding-in-progress ${className}`}>
      <h1 className="mb-16">{t("onboarding.inProgress.title")}</h1>
      <p>
        <strong>{t("onboarding.inProgress.description")}</strong>
      </p>
      <p>
        <strong>{t("onboarding.inProgress.description2")}</strong>
      </p>
    </div>
  );
};

export default OBInProgressPage;
